import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuizNavigation = ({
  currentQuestion = 1,
  totalQuestions = 10,
  selectedAnswer = null,
  canGoNext = false,
  canGoPrevious = false,
  isLastQuestion = false,
  onNext = () => { },
  onPrevious = () => { },
  onSubmitQuiz = () => { },
  onExit = () => { },
  showFeedback = false
}) => {
  return (
    <div className="px-4 py-4 border-t bg-surface border-border sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between">
          {/* Left Controls */}
          <div className="flex items-center space-x-3">
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onExit}
              className="text-text-secondary hover:text-error"
            >
              Exit Quiz
            </Button>

            {canGoPrevious && (
              <Button
                variant="outline"
                size="sm"
                iconName="ChevronLeft"
                onClick={onPrevious}
                className="min-touch-target"
              >
                Previous
              </Button>
            )}
          </div>

          {/* Center Progress Indicator */}
          <div className="items-center hidden px-4 py-2 space-x-2 rounded-lg sm:flex bg-surface-secondary">
            <Icon name="Brain" size={16} color="var(--color-accent)" strokeWidth={2} />
            <span className="text-sm font-medium text-text-primary">
              {currentQuestion} of {totalQuestions}
            </span>
          </div>

          {/* Right Controls */}
          <div className="flex items-center space-x-3">
            {!selectedAnswer && !showFeedback && (
              <div className="items-center hidden space-x-2 sm:flex text-text-muted">
                <Icon name="Info" size={16} color="currentColor" strokeWidth={2} />
                <span className="text-sm">Select an answer to continue</span>
              </div>
            )}

            {isLastQuestion && (
              <Button
                variant="success"
                size="md"
                iconName="CheckCircle2"
                iconPosition="right"
                onClick={onSubmitQuiz}
                disabled={!selectedAnswer}
                className="min-touch-target"
              >
                Submit Quiz
              </Button>
            )}
          </div>
        </div>

        {/* Mobile Progress Indicator */}
        <div className="flex justify-center mt-3 sm:hidden">
          <div className="flex items-center px-3 py-2 space-x-2 rounded-lg bg-surface-secondary">
            <Icon name="Brain" size={16} color="var(--color-accent)" strokeWidth={2} />
            <span className="text-sm font-medium text-text-primary">
              Question {currentQuestion} of {totalQuestions}
            </span>
          </div>
        </div>

        {/* Mobile Answer Reminder */}
        {!selectedAnswer && !showFeedback && (
          <div className="flex justify-center mt-3 sm:hidden">
            <div className="flex items-center space-x-2 text-text-muted">
              <Icon name="Info" size={16} color="currentColor" strokeWidth={2} />
              <span className="text-sm">Select an answer to continue</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizNavigation;